import React from 'react';

import ClassroomTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ClassroomTable />
    </div>
  );
};
